(() => {
  const handles = [
    'abito-short-romantic-garden','abito-bonnie-a-fiorellini-con-coppe','tutina-satin-balze-halter','tutina-daily','completo-righe-lurex-estate','gonna-pareo-coral-breeze','abito-balze-gioiello','completo-pois-elegance','completo-boucle-chic','abito-pizzo-romantic-chic','abito-rosalie-con-coppe-e-pizzo','abito-bandana-boho-chic','gonna-portafoglio-boho','tutina-etoile-in-pizzo','abito-costine-flower','tutina-venere-in-pizzo','completo-selene-intreccio','tutina-con-pizzo-e-cintura','abito-white-romance','completo-zebra-elegance','completo-goddess-draped','abito-flora-arricciato','abito-satin-fiocco-retro','tutina-rubino-con-coppe-e-volant','completo-aura-con-nodo'
  ];

  const money = value => {
    let amount = Number(value || 0);
    if (amount > 999) amount /= 100;
    return '€' + amount.toFixed(2).replace('.', ',');
  };

  const imageUrl = product => {
    const variantImage = product.variants?.find(v => v.featured_image?.src)?.featured_image?.src;
    return variantImage || product.images?.[0] || '';
  };

  async function restore(root) {
    if (!root || root.dataset.raFallbackLoaded === '1') return;
    const track = root.querySelector('[data-track]');
    if (!track) return;
    const state = (track.textContent || '').toLowerCase();
    if (!state.includes('impossibile') && !state.includes('caricamento')) return;

    root.dataset.raFallbackLoaded = '1';
    try {
      const products = (await Promise.all(handles.map(async handle => {
        try {
          const response = await fetch('/products/' + handle + '.js', { cache: 'force-cache' });
          if (!response.ok) return null;
          const product = await response.json();
          product.handle = handle;
          return product;
        } catch (_) {
          return null;
        }
      }))).filter(Boolean);

      if (!products.length) throw new Error('Nessun prodotto');
      track.innerHTML = '';

      products.forEach(product => {
        const article = document.createElement('article');
        article.className = 'story-product-carousel__item ra-story-fallback-card';
        const link = document.createElement('a');
        link.className = 'story-product-carousel__link';
        link.href = '/products/' + product.handle;

        const media = document.createElement('div');
        media.className = 'ra-story-fallback-card__media';
        const image = document.createElement('img');
        image.src = imageUrl(product);
        image.alt = product.title || '';
        image.loading = 'lazy';
        image.decoding = 'async';
        media.appendChild(image);

        const info = document.createElement('div');
        info.className = 'ra-story-fallback-card__info';
        const title = document.createElement('strong');
        title.textContent = product.title || '';
        const price = document.createElement('span');
        price.textContent = money(product.variants?.[0]?.price);
        info.append(title, price);
        link.append(media, info);
        article.appendChild(link);
        track.appendChild(article);
      });
    } catch (_) {
      track.innerHTML = '<div class="story-product-carousel__loading">Impossibile caricare le storie.</div>';
    }
  }

  function check() {
    document.querySelectorAll('[id^="StoryProductCarousel-"]').forEach(root => restore(root));
  }

  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(check, 800);
    setTimeout(check, 2200);
  });
  document.addEventListener('shopify:section:load', () => setTimeout(check, 300));
})();